import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { UppBaseModule } from '@unpispas/upp-base';
import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppDataModule } from '@unpispas/upp-data';

import { UppUserStartComponent } from '../components/start/upp-start';
import { UppPlaceThumbComponent } from '../components/place/upp-thumb';
import { UppUserEditComponent } from '../components/edit/upp-edit';

@NgModule({
    declarations: [
        UppUserStartComponent,
        UppPlaceThumbComponent,
        UppUserEditComponent
    ],    
    imports: [
        CommonModule, 
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        UppBaseModule,
        UppWdgtModule,
        UppDataModule    
    ],
    exports: [
        UppUserStartComponent,
        UppUserEditComponent
    ],
    providers: [],  
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ]      
})
export class FeatureUserModule {}
